<template>
  <div class="relative x-captcha-input">
    <a-input
      type="text"
      :size="size"
      :class="{ 'yy-input-xlg': xLarge }"
      class="w-full"
      :value="value"
      :placeholder="placeholder"
      @change="(event) => emits('update:value', event.target.value)"
    />
    <a-button
      v-if="!isSend"
      class="absolute right-[4px] top-[4px]"
      :size="size"
      :class="{
        'yy-btn-xlg': xLarge,
      }"
      :type="type"
      @click="submit"
    >
      {{ $t('huo-qu-yan-zheng-ma') }}
    </a-button>
    <a-button
      v-else
      :type="type"
      class="absolute right-[4px] top-[3px]"
      :size="size"
      :class="{ 'yy-btn-xlg': xLarge }"
      :disabled="true"
    >
      <span class="text-font-50">{{
        $t('zhong-xin-huo-qu-times-s', [times])
      }}</span>
    </a-button>
  </div>
</template>

<script lang="ts" setup>
import { message } from 'ant-design-vue'
import { useSendCode } from '@/hooks/useSendCode'
import { getRegisterCode, getEmailCode } from '@/api'
import { phoneReg } from '@/utils/form'
const { $t } = useNuxtApp()

const { sendCode, isSend, times } = useSendCode()
const emits = defineEmits(['update:value', 'submit'])
const props = withDefaults(
  defineProps<{
    value: string
    placeholder?: string
    data: string
    size?: 'large' | 'middle' | 'small'
    isChecked?: boolean
    currentData?: string
    xLarge?: boolean
    type?: 'primary' | 'link' | 'dashed' | 'text'
  }>(),
  {
    value: '',
    data: '',
    isChecked: true,
    type: 'link',
  }
)

const submit = async () => {
  if (!isGlobalVersion()) {
    if (!props.data || !phoneReg.test(props.data)) {
      message.warning($t('qing-shu-ru-zheng-que-de-shou-ji-hao'))
      return
    }

    if (!props.isChecked) {
      message.warning($t('qing-xian-gou-xuan-fu-wu-gui-fan'))
      return
    }

    if (props.currentData && props.currentData === props.data) {
      message.warning($t('qing-shu-ru-xin-de-shou-ji-hao'))
      return
    }
    const res = await getRegisterCode({
      mobile: props.data,
    })

    if (!res.code) {
      sendCode()
      message.success($t('yan-zheng-ma-fa-song-cheng-gong'))
    }
  } else {
    if (!props.data || !emailReg.test(props.data)) {
      message.warning($t('qing-shu-ru-zheng-que-de-you-xiang'))
      return
    }
    if (!props.isChecked) {
      message.warning($t('qing-xian-gou-xuan-fu-wu-gui-fan'))
      return
    }

    if (props.currentData && props.currentData === props.data) {
      message.warning($t('qing-shu-ru-xin-de-you-xiang-di-zhi'))
      return
    }
    const res = await getEmailCode({
      email: props.data,
    })

    if (!res.code) {
      sendCode()
      message.success($t('yan-zheng-ma-fa-song-cheng-gong'))
    }
  }
}
</script>

<style lang="scss" scoped>
.x-captcha-input {
  :deep(.ant-btn) {
    height: 22px;
    padding: 0 15px;
  }
  :deep(.ant-btn-lg) {
    height: 28px;
    padding: 0 15px;
  }
  :deep(.yy-btn-xlg) {
    height: 39px;
    padding: 6px 15px;
  }
}
</style>
